import QuoteComparisonInsights from './QuoteComparisonInsights';

export default QuoteComparisonInsights;
